import React from 'react';
import stylesPlain from './plain.module.css';

import { getDefinedValue, getDefinedItem } from '../../util/tools';
import { getDefaultStyles } from '../../util/realm/styles';

class Label extends React.Component {

	/*
		props
			title
			tooltip
			image
			style   !!! Obsolete
			styles
				wideTooltip
				divMain
				
	*/

	render() {
		let title = this.props.title;
		let tooltip = this.props.tooltip;

		let divMainStyle = Object.assign({}, 
				getDefaultStyles().label,
				getDefinedValue(this.props.style, {}), 
				getDefinedItem(this.props, ['styles', 'divMain']));
		let imageHtml = null;
		if( this.props.image )
			imageHtml = <img src={this.props.image} />
		if( tooltip ) {
			let divClassName = stylesPlain.divLabelWithTooltip;
			let wideTooltip = getDefinedItem(this.props, ['styles', 'wideTooltip'], false);
			if( wideTooltip )
				divClassName = stylesPlain.divLabelWithTooltip500px;
			return (
				<div className={divClassName} style={divMainStyle}>
					{imageHtml}{title} 
					<span className={stylesPlain.tooltiptext}>{tooltip}</span>
				</div>
			);
		} else {
			return (
				<div style={divMainStyle}>
					{imageHtml}{title} 
				</div>
			);
		}
	}

}

export default Label;